var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColumns = function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.292 2.023a2.685 2.685 0 0 1 2.684 2.683V19.29a2.685 2.685 0 0 1-2.684 2.684H4.708a2.686 2.686 0 0 1-2.683-2.684V4.706a2.684 2.684 0 0 1 2.683-2.683zm-14.584 1.2a1.484 1.484 0 0 0-1.483 1.483V19.29a1.486 1.486 0 0 0 1.483 1.483H11.4V3.223zm7.893 17.55h6.691a1.484 1.484 0 0 0 1.483-1.483V4.706a1.485 1.485 0 0 0-1.483-1.483h-6.691z"
  })));
};
export default SvgColumns;